import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export default { Wrapper };
